import { Breadcrumb, Button, Card, Input, Modal, Radio, Select } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../assests/images/quicktbreadrans.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

import {
  accountListSelector,
  profileDetailsSelector,
} from "../../store/selectors/app.selector";
import Form from "antd/es/form/Form";
import PesaLinkService from "../../services/pesa.link.services";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { CONFIG } from "../../environment";

export default function PesaDeLinkAccount() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const accountList = useSelector(accountListSelector);
  const [form] = Form.useForm();
  const profileDetails = useSelector(profileDetailsSelector);
  const [defaultAcc, setDefaultAcc] = useState("1");
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (accountList.length > 0) {
      form.setFieldsValue({
        accountNo: accountList[0].accountNo,
        defaultAccount: "1",
      });
    }
  }, [accountList]);

  const deLinkAccountVerify = useCallback(
    async (data) => {
      try {
        const req = {
          srcAccount: data.accountNo,
          phoneNumber: profileDetails.mobileNo,
          emailAddress: profileDetails.emailId,
          defaultAccount: defaultAcc,
          idNumber: profileDetails.uniqueIdValue,
        };
        const response = await PesaLinkService.DeLink(req);
        if (response.status === 200) {
          setMessage(response.data["message"]);
          setShowModal(true);
        }
      } catch (error) {}
    },
    [profileDetails, defaultAcc]
  );

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/pesaLink")}>
              {t("navigation.pesaLink", {
                defaultValue: "Pesalink",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.service_request.common_service.dlink_your_phone", {
                defaultValue: "De-Link Your Phone",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.service_request.common_service.dlink_your_phone", {
                defaultValue: "De-Link Your Phone",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <Card className="application-card ">
            <h6 className="mb-4  mt-3">
              {t("common.proceed_fill_txt", {
                defaultValue:
                  "Please fill required details, before you proceed",
              })}
            </h6>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form
                  layout="vertical"
                  onFinish={deLinkAccountVerify}
                  form={form}
                >
                  <Form.Item
                    label={t("common.account_number", {
                      defaultValue: "Account Number",
                    })}
                    name="accountNo"
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.account_no_requir", {
                          defaultValue: "Account Number is required",
                        }),
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      optionLabelProp={"value"}
                      dropdownMatchSelectWidth={false}
                    >
                      {accountList
                        .filter(
                          (ele) => ele.accountCurrency === CONFIG.CURRENCY
                        )
                        .map((account, index) => (
                          <Select.Option key={index} value={account.accountNo}>
                            <span className="acc-short-name">
                              {account?.acctShortName}
                            </span>
                            <br />
                            <span style={{ fontSize: "12px" }}>
                              {account?.accountNo}
                            </span>
                            <br />
                            <span style={{ fontSize: "12px" }}>
                              {account?.accountCurrency}
                            </span>
                            <br />
                            <span style={{ fontSize: "12px" }}>
                              {account?.branchName}
                            </span>
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                    <Form.Item
                      label={t(
                        "pages.service_request.common_service.default_account",
                        {
                          defaultValue: "Default Account",
                        }
                      )}
                      name="defaultAccount"
                      rules={[
                        {
                          required: true,
                          message: t(
                            "pages.service_request.common_service.default_account_req",
                            {
                              defaultValue: "Default Account is required",
                            }
                          ),
                        },
                      ]}
                    >
                      <Radio.Group
                        onChange={(e) => setDefaultAcc(e.target.value)}
                        className=" d-flex justify-content-between"
                      >
                        <Radio value={"1"}>
                          {t("common.yes", { defaultValue: "Yes" })}
                        </Radio>
                        <Radio value={"0"}>
                          {t("buttons.no_btn", {
                            defaultValue: "No",
                          })}
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>

                  <div className="d-flex justify-content-end mt-5">
                    <Button size="large" htmlType="submit" type="primary">
                      {t("buttons.proceed_btn", {
                        defaultValue: "Proceed",
                      })}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </Card>
        </div>

        <Modal
          open={showModal}
          footer={null}
          width={480}
          closable={false}
          maskClosable={false}
          mask={true}
          className="custom-error-modal"
        >
          <div style={{ width: 350, margin: "0 auto" }} align="center">
            <TickIcon height={65} />
            <h4 className="mb-3 mt-2">
              {t("common.success", {
                defaultValue: "Success",
              })}
            </h4>
            <p>{message}</p>

            <div align="center">
              <Button
                size="large"
                style={{ width: 100 }}
                onClick={() => {
                  setShowModal(false);
                  navigate("/pesaLink");
                }}
                type="primary"
              >
                {t("buttons.okay_btn", {
                  defaultValue: "Okay",
                })}
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}
